export const FETCH_GST_INIT_ACTION = "FETCH_GST_INIT_ACTION";
export const FETCH_GST_SUCCESS_ACTION = "FETCH_GST_SUCCESS_ACTION";
export const FETCH_GST_FAIL_ACTION = "FETCH_GST_FAIL_ACTION";

export const ADD_GST_INIT_ACTION = "ADD_GST_INIT_ACTION";
export const ADD_GST_SUCCESS_ACTION = "ADD_GST_SUCCESS_ACTION";
export const ADD_GST_FAIL_ACTION = "ADD_GST_FAIL_ACTION";

export const UPDATE_GST_STATUS_INIT_ACTION = "UPDATE_GST_STATUS_INIT_ACTION";
export const UPDATE_GST_STATUS_SUCCESS_ACTION = "UPDATE_GST_STATUS_SUCCESS_ACTION";
export const UPDATE_GST_STATUS_FAIL_ACTION = "UPDATE_GST_STATUS_FAIL_ACTION";

export const EDIT_GST_INIT_ACTION = "EDIT_GST_INIT_ACTION";
export const EDIT_GST_SUCCESS_ACTION = "EDIT_GST_SUCCESS_ACTION";
export const EDIT_GST_FAIL_ACTION = "EDIT_GST_FAIL_ACTION";

export const GST_SELECTED_PAGE_ACTION = "GST_SELECTED_PAGE_ACTION";

export function fetchGstList(value) {
    return {
        type: FETCH_GST_INIT_ACTION,
        value: value,
    };
}

export function addGst(value) {
    return {
        type: ADD_GST_INIT_ACTION,
        value: value,
    };
}

export function updateGstStatus(item, status) {
    return {
        type: UPDATE_GST_STATUS_INIT_ACTION,
        item: item,
        status: status,
    };
}

export function editGst(value) {
    return {
        type: EDIT_GST_INIT_ACTION,
        value: value,
    };
}

export function gstSelectedPage(value) {
    return {
        type: GST_SELECTED_PAGE_ACTION,
        value: value,
    };
}
